import React from 'react';
import { PROCESS_STEPS } from '../data/site';
import { Icon } from '../utils/icons';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
export function Process() {
  return <section id="forma-de-trabajo" className="bg-haze py-24 sm:py-32" data-id="element-217" data-mp="1yeyrzuqq6t2s">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-218" data-mp="23e1lqj199cvg">
        <Reveal data-id="element-219" data-mp="23drw4wk4h7qa">
          <SectionHeading eyebrow="Nuestra forma de trabajar" title="Un proceso claro, de principio a fin." description="Cinco pasos simples para que sepas siempre qué sigue, desde la primera consulta hasta mucho después de la entrega." align="center" data-id="element-220" data-mp="23c79dt41ut2z" />
        </Reveal>

        <div className="relative mt-16" data-id="element-221" data-mp="1kf5ungkp1elu">
          <div className="hidden lg:block absolute left-0 right-0 top-7 h-px bg-black/10" aria-hidden="true" data-id="element-222" data-mp="1kg7dw8bv57en" />
          <ol className="grid gap-8 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6" data-id="element-223" data-mp="rz4t6z5v45jc">
            {PROCESS_STEPS.map((step, i) => <Reveal key={step.step} delay={i * 0.1} data-id="element-224" data-mp="19lhab683hpds" data-mpi={i}>
                <li className="group relative flex flex-col" data-id="element-225" data-mp="19nc0ayy847oq">
                  <span className="relative z-10 inline-flex h-14 w-14 items-center justify-center rounded-full border border-black/10 bg-white text-brand shadow-soft transition-all duration-300 group-hover:border-brand group-hover:bg-brand group-hover:text-white" data-id="element-226" data-mp="15kxf48730vua">
                    <Icon name={step.icon} className="h-6 w-6" data-id="element-227" data-mp="qv9c92j95p4g" />
                  </span>
                  <span className="mt-6 text-xs font-semibold tracking-[0.2em] text-brand" data-id="element-228" data-mp="lvwqkl44ao3g">
                    PASO {step.step}
                  </span>
                  <h3 className="mt-2 text-lg font-semibold leading-snug text-ink" data-id="element-229" data-mp="hul7yzjnv34r">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-soft" data-id="element-230" data-mp="cwjgprc2zxi7">{step.text}</p>
                </li>
              </Reveal>)}
          </ol>
        </div>
      </div>
    </section>;
}